import { React } from "react";
import TimelineBlock from "../../components/TimelineBlock";
import { FaLink, FaBriefcase, FaGraduationCap } from "react-icons/fa";
const Timeline = () => {
  const data = [
    {
      company: "Amazon",
      isFirst: true,
      type: "work",
      link: "https://www.amazon.com",
      title: "Software Development Engineer",
      year: "",
      month: "Present",
      responsibilities: [
        "Designed and implemented core components of a warehouse management system that scaled across multiple countries and regions.",
        "Optimized API endpoints to support parallel processing which reduced average latency by 1.4 seconds.",
        "Designed and implemented an application for tracking performance of warehouse workers which provided valuable metrics to identify areas of improvement.",
        "Created base infrastructure as code packages for event handling that was extended by multiple sister teams to build on top of.",
      ],
      degree: null,
      major: null,
    },
    {
      company: "PepsiCo",
      isFirst: false,
      type: "work",
      link: "https://www.pepsico.com",
      title: "Senior Data Engineer",
      year: 2021,
      month: "July",
      responsibilities: [
        "Implemented a distributed job scheduler for timed data transfer which eliminated 90% of manual work load.",
        "Designed backend services for data monitoring and auditing thereby improving data quality and accuracy.",
        "Implemented APIs that surfaced operational data for cross organizational reporting which streamlined operational planning. Implemented a server less feedback tool to proactively notify and remediate erroneous data that reduced data quality issues by approximately 15%.",
        "Designed and implemented an inventory stock application noti{ed relevant teams about out of stock inventory in stores which increased revenue by 14%.",
      ],
      degree: null,
      major: null,
    },
    {
      company: "University of Texas at Dallas",
      isFirst: false,
      type: "study",
      link: "https://www.utdallas.edu",
      title: "Student",
      year: 2018,
      month: "August",
      responsibilities: [],
      degree: "Masters",
      major: "Information Science",
    },
    {
      company: "Cognizant Technology Solutions",
      isFirst: false,
      type: "work",
      link: "https://www.cognizant.com/us/en",
      title: "Programmer Analyst",
      year: 2016,
      month: "December",
      responsibilities: [
        "Developed a file sharing system that had 500+ internal clients Implemented ef{cient distributed storage and retrieval of time sensitive data using Hadoop and MapReduce.",
        "Designed and implemented service and frontend for API monitoring and health check that reduced critical issues by 45%.",
      ],
      degree: null,
      major: null,
    },
    {
      company: "Anna University",
      isFirst: false,
      type: "study",
      link: "https://www.annauniv.edu",
      title: "Student",
      year: 2013,
      month: "May",
      responsibilities: [],
      degree: "Bachelor of Technology",
      major: "Mechanical Engineering",
    },
  ];

  const transformed = [];

  data.forEach((item) => {
    const responsibilities = [];
    item.responsibilities.forEach((e) => {
      responsibilities.push(<li>{e}</li>);
    });

    const element = (
      <TimelineBlock
        year={item.year}
        from={item.month}
        to={""}
        isFirst={item.isFirst}
      >
        <div className="flex flex-row justify-start text-slate-700">
          <div
            className="self-center font-google-roboto text-2xl
           font-medium text-light-analogous-1 "
          >
            {item.company}
          </div>
          <div className="ml-5">
            {item.type === "work" ? (
              <FaBriefcase className="text-sm dark:text-dark-primary-2" />
            ) : (
              <FaGraduationCap className="text-lg dark:text-dark-primary-2" />
            )}
          </div>
          <a href={item.link}>
            <FaLink className="ml-5 text-sm dark:text-dark-primary-2" />
          </a>
        </div>
        <div className="text-2xl font-medium text-light-analogous-2">
          {item.title}
        </div>
        {responsibilities ? (
          <ul className="m-5 list-disc space-y-1 text-xl font-medium leading-8 dark:text-dark-primary-2">
            {responsibilities}
          </ul>
        ) : (
          ""
        )}
        {item.degree && item.major ? (
          <div className="dark:text-dark-primary-2">
            <div>{item.degree}</div>
            <div>{item.major}</div>
          </div>
        ) : (
          ""
        )}
      </TimelineBlock>
    );
    transformed.push(element);
  });

  return (
    <div class="flex h-full flex-col items-start justify-evenly p-10 font-google-roboto">
      {transformed}
    </div>
  );
};

export default Timeline;
